import { styled } from 'styled-components';

export const P = styled.p`
  padding: var(--spacing-medium);
`;
